import { FieldHtmlNameUtil } from '@onshape/www-inertia';
import type UnifiedSignupScreenComponent from '../UnifiedSignupScreenComponent';
import AbstractSignupScreen from './AbstractSignupScreen';
import type { UnifiedSignupScreenName } from '../UnifiedSignupScreenName';

export default class EmailStatusErrorSignupScreen extends AbstractSignupScreen {
  public readonly screenName: UnifiedSignupScreenName = 'uss-signup-fail';

  public getVisibleComponents(): UnifiedSignupScreenComponent[] {
    return [];
  }

  public getValidatedComponents(): UnifiedSignupScreenComponent[] {
    return this.getVisibleComponents();
  }

  public predicate(): boolean {
    const { emailStatus } = this.sessionInfo.value;
    if (emailStatus == null) {
      return false;
    }

    if (emailStatus !== 'INVALID') {
      return false;
    }

    return true;
  }

  public async toNextScreen(): Promise<boolean> {
    this.sessionInfo.value.completedDetailsScreens.push(this.screenName);
    return true;
  }

  public override async initWatchers(): Promise<void> {
    super.initWatchers();

    document.querySelectorAll('[hekate-data="email"]').forEach((elm) => {
      const firstName = this.getField(FieldHtmlNameUtil.email).val;
      elm.textContent = `${firstName}`;
    });
  }

  public getProgress(): number {
    const container = document.querySelector('.hekate-progress-bar') as HTMLDivElement;
    const progressBar = container.querySelector('.progress-bar') as HTMLDivElement;
    progressBar.classList.remove('bg-success');
    progressBar.classList.add('bg-danger');
    return 100;
  }
}
